<template>
  <q-btn
    v-if="isGranted('INVITE_USER')"
    icon="fa fa-plus"
    :label="label"
    v-bind="$attrs"
    @click="openModal"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { AccountContextMixin } from '@/mixins';
import { User } from '@/type';
import openModal from '@/components/modal';
import InviteUserModal from './InviteUserModal.vue';

export default defineComponent({
  emits: ['invited'],
  mixins: [AccountContextMixin, AccountContextMixin],
  props: {
    label: {
      type: String,
      default: 'Invite User',
    },
  },
  methods: {
    openModal() {
      const props = { accountId: this.accountId };
      openModal(InviteUserModal, props).onOk((user: User) => {
        this.$emit('invited', user);
      });
    },
    isGranted,
  },
});
</script>
